module.exports = __webpack_public_path__ + "static/media/recordtv.1b66da4c.webp";